import {
  CLIENT_FUND_SUPERVISOR_GET_ALL,
  CLIENT_FUND_SUPERVISOR_GET_ALL_SUCCESS,
  CLIENT_FUND_SUPERVISOR_GET_ALL_ERROR,
  CLIENT_FUND_SUPERVISOR_GET_BY_ID,
  CLIENT_FUND_SUPERVISOR_GET_BY_ID_SUCCESS,
  CLIENT_FUND_SUPERVISOR_GET_BY_ID_ERROR,
  CLIENT_FUND_SUPERVISOR_ADD_NEW,
  CLIENT_FUND_SUPERVISOR_ADD_NEW_SUCCESS,
  CLIENT_FUND_SUPERVISOR_ADD_NEW_ERROR,
  CLIENT_FUND_SUPERVISOR_EDIT,
  CLIENT_FUND_SUPERVISOR_EDIT_SUCCESS,
  CLIENT_FUND_SUPERVISOR_EDIT_ERROR,
  CLIENT_FUND_SUPERVISOR_DELETE,
  CLIENT_FUND_SUPERVISOR_DELETE_SUCCESS,
  CLIENT_FUND_SUPERVISOR_DELETE_ERROR,
  CLIENT_FUND_SUPERVISOR_EMAIL_NOTIFICATION,
} from '../actions';

const initialState = {
  items: [],
  item: null,
  loading: false,
  error: null,
};

export default (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case CLIENT_FUND_SUPERVISOR_DELETE:
    case CLIENT_FUND_SUPERVISOR_EDIT:
    case CLIENT_FUND_SUPERVISOR_ADD_NEW:
    case CLIENT_FUND_SUPERVISOR_GET_BY_ID:
    case CLIENT_FUND_SUPERVISOR_GET_ALL:
    case CLIENT_FUND_SUPERVISOR_EMAIL_NOTIFICATION:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case CLIENT_FUND_SUPERVISOR_GET_BY_ID_SUCCESS:
      return {
        ...state,
        item: payload,
        loading: false,
      };

    case CLIENT_FUND_SUPERVISOR_GET_ALL_SUCCESS:
      return {
        ...state,
        items: payload,
        loading: false,
      };

    case CLIENT_FUND_SUPERVISOR_ADD_NEW_SUCCESS:
      return {
        ...state,
        loading: false,
        item: payload,
        items: state.items.concat(payload),
      };

    case CLIENT_FUND_SUPERVISOR_EDIT_SUCCESS:
      return {
        ...state,
        loading: false,
        items: state.items.map(c => {
          return c.id === payload.id ? payload : c;
        }),
        item: payload,
        error: null,
      };

    case CLIENT_FUND_SUPERVISOR_DELETE_SUCCESS:
      return {
        ...state,
        loading: false,
        items: state.items.filter(c => c.id !== payload),
        error: null,
      };

    case CLIENT_FUND_SUPERVISOR_GET_ALL_ERROR:
    case CLIENT_FUND_SUPERVISOR_GET_BY_ID_ERROR:
    case CLIENT_FUND_SUPERVISOR_ADD_NEW_ERROR:
    case CLIENT_FUND_SUPERVISOR_EDIT_ERROR:
    case CLIENT_FUND_SUPERVISOR_DELETE_ERROR:
      return {
        ...state,
        loading: false,
        error: payload,
      };

    default:
      return { ...state };
  }
};
